type CadEnv = 'demo-c' | 'live';

type WwwEnv = 'dev' | 'stage' | 'live';

type WwwEnvToCadEnv = { [key: string]: CadEnv };

type WwwDomainToWwwEnvMap = { [key: string]: WwwEnv };

type CadEnvToProductDomainMap = { [key: string]: string };

type CadDomainHelperConfig = {
  domainToWwwEnv: WwwDomainToWwwEnvMap;
  wwwEnvToCadEnv: WwwEnvToCadEnv;
  cadEnvToProductDomain: CadEnvToProductDomainMap;
};

// type KvpConfig = {
//   Key: string;
//   Value: string;
// };

class CadDomainHelper implements ICadDomainHelper {
  private readonly config: Promise<CadDomainHelperConfig>;

  constructor(configProvider: () => Promise<CadDomainHelperConfig>) {
    this.config = configProvider();
  }

  private async getWwwEnv(): Promise<WwwEnv> {
    const config = await this.config;
    return config.domainToWwwEnv[document.location.host] || 'live';
  }

  private async getCadEnv(): Promise<CadEnv> {
    const config = await this.config;
    const wwwEnv = await this.getWwwEnv();
    return config.wwwEnvToCadEnv[wwwEnv] || 'live';
  }

  public async getProductDomain(): Promise<string> {
    const cadEnv = await this.getCadEnv();
    const config = await this.config;
    return config.cadEnvToProductDomain[cadEnv] || 'https://cad.onshape.com';
  }
}

// TODO get this from the a `fetch` request so we can add more domains dynamically outside of prod
// const reduceFunction = (acc: Record<string, string>, current: KvpConfig) => {
//   acc[current.Key] = current.Value;
//   return acc;
// };

const cadDomainHelper = new CadDomainHelper(async () => {
  return {
    domainToWwwEnv: {
      'www.onshape.com': 'live',
    },
    wwwEnvToCadEnv: {
      live: 'live',
    },
    cadEnvToProductDomain: {
      live: 'https://cad.onshape.com',
    },
  };
});

export default defineNuxtPlugin(() => {
  if (!window || window.cadDomainHelper) {
    return;
  }
  window.cadDomainHelper = cadDomainHelper;
});
